import { aboutValues, siteInfo, testimonials } from "@/mocks/portal";

export default function AboutSection() {
  return (
    <section id="about" className="w-full bg-background-50 py-14 md:py-20">
      <div className="max-w-content mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
          <div className="w-full aspect-[4/3] rounded-card overflow-hidden border border-background-200 bg-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20reading%20corner%20with%20a%20neat%20stack%20of%20magazines%20and%20soft%20morning%20light%2C%20lifestyle%20editorial%20photography%2C%20cream%20and%20amber%20tones%2C%20quiet%20calm%20atmosphere%2C%20clean%20composition%2C%20high%20detail&width=900&height=700&seq=kl-about-2026&orientation=landscape"
              alt="看料入口 品牌介绍 内容整理工作场景"
              title="看料入口 品牌介绍"
              className="w-full h-full object-cover object-top"
            />
          </div>

          <div>
            <span className="inline-flex items-center gap-1.5 text-xs md:text-sm font-medium text-primary-600">
              <i className="ri-information-line"></i>
              关于我们
            </span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              {siteInfo.name}：让「抵达」比「搜索」更快
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">{siteInfo.intro}</p>

            <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
              {aboutValues.map((value) => (
                <div
                  key={value.title}
                  className="rounded-card border border-background-200 bg-background-50 p-4"
                >
                  <span className="w-9 h-9 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center">
                    <i className={`${value.icon} text-lg`}></i>
                  </span>
                  <h3 className="mt-3 font-heading text-base font-bold text-foreground-950">{value.title}</h3>
                  <p className="mt-1 text-xs md:text-sm text-foreground-600 leading-relaxed">{value.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 md:mt-16">
          <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">读者怎么说</h3>
          <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {testimonials.map((item) => (
              <figure
                key={item.id}
                className="rounded-card border border-background-200 bg-background-100 p-5 flex flex-col h-full"
              >
                <i className="ri-double-quotes-l text-2xl text-primary-400"></i>
                <blockquote className="mt-2 text-sm text-foreground-700 leading-relaxed flex-1">
                  {item.content}
                </blockquote>
                <figcaption className="mt-3 pt-3 border-t border-background-200 text-xs text-foreground-500">
                  {item.name}
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}